import Button from '@/common/components/base/button/Button';
import MobileInput from '@/common/components/base/input/mobileInput/MobileInput';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import { PHONE_NUMBER_RULE } from '@/common/utils/rules/phoneNumber.rules';
import { POSTAL_CODE_RULE } from '@/common/utils/rules/postalCode.rules';
import { requiredText } from '@/common/utils/rules/publicRules';
import { ADJUSTER_REPORT_BODY_DAMAGE_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
import { getBodyOwnerUserInformationQueryOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyOwnerUserInformation/getBodyOwnerUserInformationQueryOptions';
import { patchBodyOwnerContactInformationQueryOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyOwnerContactInformation/patchBodyOwnerContactInformationQueryOptions';
import { BodyContactInformationOwnerType } from '@/modules/adjusterReportModules/Insurer-information/types/BodyOwnerType';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

export const BodyOwnerContract = () => {
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const navigate = useNavigate();

  const { data } = useQuery(getBodyOwnerUserInformationQueryOptions(+id!));

  const mutate = useMutation(patchBodyOwnerContactInformationQueryOptions());

  const methods = useForm<BodyContactInformationOwnerType>({
    mode: 'onChange',
  });
  const submitHandler = () => {
    const temporaryObject: BodyContactInformationOwnerType = {
      // eslint-disable-next-line no-extra-boolean-cast
      address: !!methods.getValues('address')
        ? methods.getValues('address')
        : null,
      postal_code: methods.getValues('postal_code') || null,
      phone: methods.getValues('phone') || null,
      city_code: methods.getValues('city_code') || null,
      phone_number: methods.getValues('phone_number') || null,
    };

    mutate.mutate(
      { id: id!, formData: temporaryObject },
      {
        onSuccess: () => {
          navigate(-1);
        },
      },
    );
  };

  useEffect(() => {
    if (data) {
      methods.reset({
        ...data.contact_information,
      });
    }
  }, [data, searchParams]);
  const previousStep = () => {
    navigate(
      ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_INFORMATION({
        id: id!,
      }).DRIVER_OWNER_INFORMATION.owner,
      {
        replace: true,
      },
    );
  };
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(submitHandler)}>
        <Flex flexDirection="column" gap="10px">
          <MobileInput
            name="phone_number"
            label="تلفن همراه"
            rules={{
              required: requiredText,
            }}
          />
          <Box display="flex" flexDirection="row" gap="10px">
            <Box flexBasis={'80%'}>
              <TextInput
                name="phone"
                label="تلفن ثابت"
                max={8}
                key={'phone'}
                rules={{ ...PHONE_NUMBER_RULE, required: requiredText }}
                placeholder="XX-XX-XX-XX"
                noCharInput={true}
                direction="ltr"
              />
            </Box>
            <Box flexBasis={'30%'}>
              <TextInput
                name="city_code"
                key={'city_code'}
                rules={{
                  minLength: { message: 'پیش شماره شهر 3 رقمی است', value: 3 },
                  required: { message: requiredText, value: true },
                }}
                max={3}
                placeholder="کد شهر"
                noCharInput={true}
                direction="ltr"
              />
            </Box>
          </Box>
          <TextInput
            name="postal_code"
            label="کد پستی"
            optionalLabel
            max={10}
            key={'economic_code'}
            noCharInput
            rules={POSTAL_CODE_RULE}
          />
          <TextInput
            name="address"
            label="ادرس"
            optionalLabel
            key={'address'}
          />
          <Flex w="100%" gap={16} mt="4px">
            <Button fullWidth variant="outlined" onClick={previousStep}>
              مرحله قبل
            </Button>{' '}
            <Button
              onClick={methods.handleSubmit(submitHandler)}
              type="submit"
              width="100%"
              disabled={!methods?.formState?.isValid}
            >
              تائید و ادامه
            </Button>
          </Flex>
        </Flex>
      </form>
    </FormProvider>
  );
};
